export const ROUTES = {
  LOGIN: () => '/auth',
  AUTH:() => '/auth/*',
  PROFILE: () => '/profile',
  PROFILE_CREATE: () => '/profile/create',
  MOLECULES: () => '/molecules',
  MOLECULE_DETAIL: (id: string) => `/molecules/${id}`,
  SYMPTOMS: () => '/symptoms',
  SYMPTOM_DETAIL: (id: string) => `/symptoms/${id}`,
  HOME: () => '/',
  TRAINING: () => '/training',
  QUIZZES: () => '/training/quizzes',
  QUIZZ: () => '/training/quizz',
  INFORMATIONS: () => '/informations',
  LEGAL_NOTICE: () => '/informations/legal_notice',
  BIBLIOGRAPHY: () => '/informations/bibliography',
  NEWS: () => '/informations/news',
  ARTICLE: (id: string) => `/informations/news/article/${id}`,
  EXPERTS: () => '/informations/experts',
  REGISTER: () => '/register',
  ANY: () => '/*'
};